<template>
  <div class="copyright">
        Copyright @<strong> {{ siteName }}</strong> All Rights Reserved.
  </div>
</template>

<script>
export default {
    computed:{
        siteName(){
             return this.$store.state.siteName;
        }
    }
}
</script>

<style>
.copyright{
    text-align: center;
}
</style>
